// extracted by mini-css-extract-plugin
export default {"buttonSignup":"Signup_buttonSignup__Qej19","link":"Signup_link__1kMIX"};